import { Box, Button } from '@mui/material'
import { SectionHeader } from 'components/SectionHeader'
import { SettingsDetailsHeader } from './SettingsDetailsHeader'
import { useState } from 'react'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { useGetCelebrations } from 'hooks/api/Settings/useGetCelebrations'
import { SimpleAnimationCard } from 'components/SimpleAnimationCard/SimpleAnimationCard'
import { UploadAnimationFile } from './UploadAnimationFile'

export type CelebrationType =
  | 'TierAdvancement_Member'
  | 'TierAdvancement_Insider'
  | 'TierAdvancement_Elite'
  | 'TierAdvancement_VIP'
  | 'BadgeRewardCelebration'

const celebrationCards: Array<{
  type: CelebrationType
  title: string
  description: string
}> = [
  {
    type: 'TierAdvancement_Insider',
    title: 'Tier Advancement - Insider Animation:',
    description: 'Tier Advancement - Insider',
  },
  {
    type: 'TierAdvancement_Elite',
    title: 'Tier Advancement - Elite Animation:',
    description: 'Tier Advancement - Elite',
  },
  {
    type: 'TierAdvancement_VIP',
    title: 'Tier Advancement - VIP Animation:',
    description: 'Tier Advancement - VIP',
  },
  {
    type: 'BadgeRewardCelebration',
    title: 'Badge Reward Celebration Animation:',
    description: 'Badge Reward Celebration',
  },
]

export const SettingsDetailsCelebrations = () => {
  const [isFileModalOpen, setIsFileModalOpen] = useState(false)

  const toggleFileModalIsOpen = async () => {
    setIsFileModalOpen(!isFileModalOpen)
  }

  const [celebrationAnimationId, setCelebrationAnimationId] = useState(0)
  const [celebrationAnimationType, setCelebrationAnimationType] = useState(
    '' as CelebrationType
  )
  const [celebrationAnimationDescription, setCelebrationAnimationDescription] =
    useState('')
  // Local override sources after upload
  const [animationOverrides, setAnimationOverrides] = useState<
    Partial<Record<CelebrationType, string>>
  >({})

  const celebrationsQuery = useGetCelebrations()

  if (celebrationsQuery.isPending) {
    return <ActivityIndicator />
  }

  const getAnimationFile = (type: CelebrationType) => {
    // Prefer locally refreshed override
    if (animationOverrides[type]) return animationOverrides[type]
    const cel = celebrationsQuery.data?.find((c) => c.type === type)
    return cel?.fileName ?? undefined
  }

  // Callback passed to uploader
  const onAnimationRefresh = (src: string) => {
    setAnimationOverrides((prev) => ({
      ...prev,
      [celebrationAnimationType]: src,
    }))
  }

  const getAnimationId = (type: CelebrationType) => {
    const cel = celebrationsQuery.data?.find((c) => c.type === type)
    return cel?.id ?? 0
  }

  const toggleDialog = (
    id: number,
    type: CelebrationType,
    description: string
  ) => {
    setCelebrationAnimationId(id)
    setCelebrationAnimationType(type)
    setCelebrationAnimationDescription(description)
    void toggleFileModalIsOpen()
  }

  return (
    <SettingsDetailsHeader currentTab="/Settings/SettingsDetailsPageCelebrations">
      <Box className="gap-12 flex flex-col">
        <Box>
          <SectionHeader title="Celebrations" showButton={false} />

          {/*           <Box className="pb-3">Tier Advancement - Member Animation:</Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mb: 6,
            }}
          >
            <SimpleAnimationCard
              animationSource={getAnimationFile('TierAdvancement_Member')}
            />
            <Button
              onClick={() =>
                toggleDialog(
                  getAnimationId('TierAdvancement_Member'),
                  'TierAdvancement_Member',
                  'Tier Advancement - Member'
                )
              }
              variant="contained"
            >
              Upload
            </Button>
          </Box> */}

          {celebrationCards.map(({ type, title, description }) => (
            <Box key={type}>
              <Box className="pb-3">{title}</Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mb: 6,
                }}
              >
                <SimpleAnimationCard animationSource={getAnimationFile(type)} />
                <Button
                  onClick={() =>
                    toggleDialog(getAnimationId(type), type, description)
                  }
                  variant="contained"
                >
                  Upload
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <UploadAnimationFile
        celebrationAnimationId={celebrationAnimationId}
        celebrationAnimationType={celebrationAnimationType}
        celebrationAnimationDescription={celebrationAnimationDescription}
        isModalOpen={isFileModalOpen}
        toggleModalIsOpen={toggleFileModalIsOpen}
        onAnimationRefresh={onAnimationRefresh}
      />
    </SettingsDetailsHeader>
  )
}
